import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

// Types
export interface ImageUploadState {
  uploading: boolean;
  uploadedUrls: string[];
  error: string | null;
  success: boolean;
}

export interface UploadImagePayload {
  file?: File;
  pexelsUrl?: string;
  templateUrl?: string;
}

export interface UploadImageSuccessPayload {
  imageUrl: string;
}

const initialState: ImageUploadState = {
  uploading: false,
  uploadedUrls: [],
  error: null,
  success: false,
};

const imageUploadSlice = createSlice({
  name: 'imageUpload',

  initialState,

  reducers: {
    uploadImageRequest: (
      state,
      action: PayloadAction<UploadImagePayload>
    ) => {
      state.uploading = true;
      state.error = null;
      state.success = false;
    },

    uploadImageSuccess: (
      state,
      action: PayloadAction<UploadImageSuccessPayload>
    ) => {
      state.uploading = false;
      state.uploadedUrls.push(
        action.payload.imageUrl
      );
      state.success = true;
      state.error = null;
    },

    uploadImageFailure: (
      state,
      action: PayloadAction<string>
    ) => {
      state.uploading = false;
      state.error = action.payload;
      state.success = false;
    },

    resetImageUpload: (state) => {
      state.uploading = false;
      state.uploadedUrls = [];
      state.error = null;
      state.success = false;
    },

    clearImageUploadError: (state) => {
      state.error = null;
    },

    removeUploadedUrl: (
      state,
      action: PayloadAction<string>
    ) => {
      state.uploadedUrls =
        state.uploadedUrls.filter(
          (url) => url !== action.payload
        );
    },
  },
});

export const {
  uploadImageRequest,
  uploadImageSuccess,
  uploadImageFailure,
  resetImageUpload,
  clearImageUploadError,
  removeUploadedUrl,
} = imageUploadSlice.actions;

export default imageUploadSlice.reducer;
